import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import styles from "./AlertModal.module.scss";

interface IProps {
  show: boolean;
  children: ReactNode;
  variant?: "success" | "error";
  buttons?: {
    variant: "success" | "danger";
    onClick: () => void;
    text: string;
  }[];
  onHide?: () => void;
}

const AlertModal = (props: IProps) => {
  const {
    show = false,
    variant = "success",
    buttons = [
      {
        variant: "success",
        onClick: () => {},
        text: "OK",
      },
    ],
    onHide,
  } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className={styles.modalOverlay}
      style={{ zIndex: 9999 }}
    >
      <Modal.Body className={styles.modalBody}>
        <Row className="justify-content-center align-items-center">
          <Col className="col-10">
            <Row className="align-items-center">
              <Col className="col-auto">
                {variant === "success" ? (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="3x"
                    className={styles.successIcon}
                  />
                ) : (
                  <AiFillCloseCircle size={48} className={styles.errorIcon} />
                )}
              </Col>
              <Col className={styles.content}>{props.children}</Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        {buttons.map((button, index) => (
          <Button
            key={index}
            variant={button.variant}
            onClick={button.onClick}
            className={styles.button}
          >
            {button.text}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;
